import { BreakPointCondition, UI, useBreakpointIf, HStack, VStack } from '@genial/components';
import { BoxBorder, Color, ColorTypes, Spacing } from '@genial/design-tokens';
import React from 'react';
import { FlatList } from 'react-native';

import { FixedIncomeDetailsProps } from '../FixedIncomeDetails';

export const YieldComparisonPanel: React.FC<FixedIncomeDetailsProps> = ({ product }) => {
  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');
  const isTablet = useBreakpointIf(BreakPointCondition.EqualOrDown, 'lg');

  const getInfos = (): {
    label: string;
    value: string;
    color?: ColorTypes.Option;
  }[] => {
    const curveColor = product.isCurvePricingMethod ? undefined : 'neutral.medium';
    const marketColor = product.isCurvePricingMethod ? 'neutral.medium' : undefined;
    return [
      { label: 'PU curva', value: product.curvePUNormalized, color: curveColor },
      { label: 'Vl.bruto curva', value: product.curveValueNormalized, color: curveColor },
      { label: 'Variação curva', value: product.curveVariationNormalized, color: curveColor },
      { label: 'PU mercado', value: product.marketPUNormalized, color: marketColor },
      { label: 'Vl.bruto mercado', value: product.marketValueNormalized, color: marketColor },
      { label: 'Variação mercado', value: product.marketVariationNormalized, color: marketColor },
    ];
  };

  const renderInfos = () => {
    const infos = getInfos();
    if (isMobile) {
      return (
        <VStack space={Spacing['stack.nano']}>
          {infos.map((item) => (
            <HStack justifyContent="space-between" key={item.label} w="full">
              <UI.Text color={item.color || 'neutral.black'} variant="semibold">
                {item.label}
              </UI.Text>
              <UI.Text color={item.color || 'neutral.darkest'}>{item.value}</UI.Text>
            </HStack>
          ))}
        </VStack>
      );
    }

    return (
      <FlatList
        key={`flatList-fixedIncome-detail${isTablet}`}
        style={{ overflow: 'visible' }}
        columnWrapperStyle={{ justifyContent: 'space-between' }}
        keyExtractor={(item) => `${item.label}-${isTablet}`}
        data={infos}
        renderItem={({ item }) => (
          <VStack space={Spacing['stack.quarck']}>
            <UI.Text variant="semibold" color={item.color}>
              {item.label}
            </UI.Text>
            <UI.Text color={item.color || 'neutral.darkest'}>{item.value}</UI.Text>
          </VStack>
        )}
        numColumns={infos.length}
      />
    );
  };

  return (
    <VStack p={Spacing['inset.nano']} space={Spacing['stack.xxxs']} w="full">
      <VStack p={Spacing['inset.xs']} bgColor={Color.background} borderRadius={BoxBorder.heavy}>
        {renderInfos()}
      </VStack>
    </VStack>
  );
};
